import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_BIDDERS } from './api/query'
import { WorkspaceBidderSliceDTO } from './api/types'
import { DEFAULT_SORT } from './constants'
import { UseGetWorkspaceBidders, WorkspaceBidderSlice } from './types'

export const useGetWorkspaceBidders = (): UseGetWorkspaceBidders => {
  const { workspaceId } = useWorkspaceParam()
  const [workspaceBidders, setWorkspaceBidders] = useState<WorkspaceBidderSlice[]>([])

  const { loading } = useQuery(GET_WORKSPACE_BIDDERS, {
    onCompleted: ({ workspaceBidders: { nodes } }): void => {
      if (nodes) {
        setWorkspaceBidders(
          nodes.map(
            (workspaceBidder: WorkspaceBidderSliceDTO): WorkspaceBidderSlice =>
              fromDTO(workspaceBidder),
          ),
        )
      }
    },
    variables: {
      sort: DEFAULT_SORT,
      workspaceId,
    },
  })

  return {
    loading,
    workspaceBidders,
  }
}
